import { apiClient } from './config'

export const SUBSCRIPTION_PLANS = {
  FREE: 'FREE',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE',
}

export const subscriptionsService = {
  async getCurrentSubscription() {
    return apiClient.get('/subscriptions')
  },

  async getAvailablePlans() {
    return apiClient.get('/subscriptions/plans')
  },

  async createCheckoutSession(plan) {
    return apiClient.post('/subscriptions/checkout', { plan })
  },

  async getPortalUrl() {
    return apiClient.post('/subscriptions/portal')
  },

  async upgradeToPro() {
    return this.createCheckoutSession(SUBSCRIPTION_PLANS.PRO)
  },

  async upgradeToEnterprise() {
    return this.createCheckoutSession(SUBSCRIPTION_PLANS.ENTERPRISE)
  },
}
